// extracted by mini-css-extract-plugin
module.exports = {"main_content_container":"LimitActionModal_main_content_container__1l9Wt","info_container":"LimitActionModal_info_container__2bex_"};